import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { Outlet, useNavigate, useLocation, useParams } from "react-router-dom";
import MobileSideNavbar from "../../Components/MobileSideNavbar/MobileSideNavbar";
import SideNavbar from "../../Components/SideNavbar/SideNavbar";
import TopNavbar from "../../Components/TopNavbar/TopNavbar";
import { MdKeyboardArrowUp } from "react-icons/md";
import UserDetail from "../../Pages/NewUserPages/UserDetail";

import { Button, Steps, theme, notification } from "antd";
import {
  GetDropDownApi,
  GetSingleEmployeeData,
} from "../../Services/CommonApis";
import { arrayToOptions } from "../../Services/GeneralFunctions";
import axios from "axios";
import {
  getEmployeeDetailApi,
  getEmployeeDetailApi2,
} from "../../Services/EmployeeOnboarding";
import { PageLoader } from "../../Services/PageLoader";
import { Loader } from "../../Services/Loader";

export default function NewUser() {
  const [api, contextHolder] = notification.useNotification();
  const [isNavbarOpen, setIsNavbarOpen] = useState(false);
  const [responseData, setResponseData] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [dropDowns, setDropDowns] = useState(null);
  const [profileData, setProfileData] = useState(null);
  const [currentStep, setCurrentStep] = useState("personal");
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [currentInable, setCurrentInable] = useState(true);
  const [isLoadingData, setIsLoadingData] = useState(false);
  const [isPageLoading, setIsPageLoading] = useState(true);

  const type = sessionStorage.getItem("userType");

  const [maxCompletedStep, setMaxCompletedStep] = useState(0);

  const navigate = useNavigate();
  const location = useLocation();
  const pathSegment = location.pathname.split("/").pop();

  const stepRoutes = [
    "personal",
    "identity-detail",
    "bank-details",
    "documents",
    "nominees",
    "offer-letter",
  ];

  const stepKeys = [
    "personal_details",
    "contact_details",
    "address_details",
    "education_details",
    "know_my_team",
  ];

  const identityRelatedKeys = [
    "id_cards",
    "employment_history",
    "reference_details",
    "job_details",
    "esic_details",
    "pf_details",
  ];

  const sectionToRouteMap = {
    personal_details: "personal",
    contact_details: "identity-detail",
    address_details: "bank-details",
    education_details: "documents",
    know_my_team: "nominees",
  };

  const { id } = useParams();
  const handleNavigate = (url) => {
    navigate(
      `/${type === "admin" ? `admin/employees-verification/${id}` : "new-user"}/${url}`
    );
  };
  const getStepper = async () => {
    try {
      let data = {};

      if (type !== "admin") {
        data = await axios.get("/api/employees/section-completion");
      }

      const completion = data?.data?.completion_status || {};
      const hasBankDetails = completion["bank_details"];
      const hasDoc = completion["documents"];
      const hasNominee = completion["nominees"];
      let Appointment = false;

      // console.log("Completion status:", completion);
      // console.log("Bank Details Present:", hasBankDetails);
      // console.log("Documents Present:", hasDoc);
      // console.log("Current Path:", location.pathname);

      const currentRoute = location.pathname.split("/").pop();

      const stepsOrder = [
        "personal",
        "identity-detail",
        "bank-details",
        "documents",
        "nominees",
        "offer-letter",
      ];

      let maxStepIndex = 0;
      if (hasNominee) {
        maxStepIndex = stepsOrder.indexOf("nominees");
        const isOfferLetter = await axios.get(
          "/api/employees/employee-offer-letter "
        );
        if (isOfferLetter?.data?.success) {
          maxStepIndex = stepsOrder.indexOf("offer-letter");
          Appointment = true;
        }
      } else if (hasDoc) {
        maxStepIndex = stepsOrder.indexOf("documents");
      } else if (hasBankDetails) {
        maxStepIndex = stepsOrder.indexOf("bank-details");
      } else {
        for (let i = 0; i < stepsOrder?.length; i++) {
          const stepKey = stepsOrder[i];
          if (!completion?.[stepKey]) {
            maxStepIndex = i - 1;
            break;
          }
          maxStepIndex = i;
          if (stepKey === "bank-details") break;
        }
        if (maxStepIndex < 0) maxStepIndex = 0;
      }

      setMaxCompletedStep(maxStepIndex);

      if (isInitialLoad) {
        setIsInitialLoad(false);

        if (Appointment) {
          setCurrentStep("offer-letter");
          setCurrentInable("offer-letter");
          if (currentRoute !== "offer-letter") {
            handleNavigate("offer-letter");
            // navigate(`/new-user/`);
          }
          return;
        }
        if (hasNominee) {
          setCurrentStep("nominees");
          setCurrentInable("nominees");
          if (currentRoute !== "nominees") {
            handleNavigate("nominees");
            // navigate(`/new-user/`);
          }
          return;
        }

        if (hasDoc) {
          setCurrentStep("documents");
          setCurrentInable("documents");
          if (currentRoute !== "documents") {
            handleNavigate("documents");
            // navigate(`/new-user/documents`);
          }
          return;
        }

        if (hasBankDetails) {
          setCurrentStep("bank-details");
          setCurrentInable("bank-details");
          if (currentRoute !== "bank-details") {
            handleNavigate("bank-details");
            // navigate(`/new-user/bank-details`);
          }
          return;
        }

        const hasIdentityData = identityRelatedKeys.some(
          (key) => completion[key]
        );

        if (hasIdentityData) {
          setCurrentStep("identity-detail");
          setCurrentInable("identity-detail");
          if (currentRoute !== "identity-detail") {
            handleNavigate("identity-detail");
            // navigate(`/new-user/identity-detail`);
          }
          return;
        }

        const incompleteStepKey = stepKeys.find((key) => !completion[key]);
        const nextStep = incompleteStepKey
          ? sectionToRouteMap[incompleteStepKey]
          : "personal";

        setCurrentStep(nextStep);
        if (currentRoute !== nextStep) {
          handleNavigate(nextStep);
          // navigate(`/new-user/${nextStep}`);
        }
      } else {
        if (stepRoutes.includes(currentRoute)) {
          setCurrentStep(currentRoute);
        }
      }
    } catch (error) {
      setCurrentStep("personal");
      setMaxCompletedStep(0);
    }
  };

  const fetchEmployeeDetail = async (id1) => {
    setIsLoadingData(true);
    let data = {};
    const type = sessionStorage.getItem("userType");

    if (type) {
      try {
        setIsLoading(true);

        if (type === "admin") {
          data = await getEmployeeDetailApi2(id);
        } else {
          data = await getEmployeeDetailApi();
        }

        if (!data?.data?.success) {
          // api.success({
          //   message: data?.data?.message,
          //   placement: "top",
          // });
          // return;
        }

        setResponseData(data?.data?.data);
      } catch (error) {
        api.error({
          message: error.message || "Network error",
          placement: "top",
        });
      } finally {
        setIsLoading(false);
        setIsLoadingData(false);
      }
    }
  };

  const getAllDropDowns = async () => {
    try {
      const data = await GetDropDownApi("");
      if (data.data.success) {
        const optionsArray = {};
        data.data.data.forEach(
          (val) => (optionsArray[val?.field] = arrayToOptions(val?.value))
        );
        setDropDowns(optionsArray);
      } else {
        api.error({
          message: "Error while fetching dropdowns",
          description: data.data.message,
          placement: "top",
        });
      }
    } catch (err) {
      api.error({
        message: err.message,
        description: "Try to check your Internet Connection",
        placement: "top",
      });
    }
  };

  const getProfileData = async () => {
    setIsPageLoading(true);
    let data = {};
    const type = sessionStorage.getItem("userType");

    if (type) {
      try {
        setIsLoading(true);

        if (type === "admin") {
          data = await getEmployeeDetailApi2(id);
        } else {
          data = await getEmployeeDetailApi();
        }

        if (!data?.data?.success) {
          // api.success({
          //   message: data?.data?.message,
          //   placement: "top",
          // });
          // return;
        }

        setResponseData(data?.data?.data);
      } catch (error) {
        api.error({
          message: error.message || "Network error",
          placement: "top",
        });
      } finally {
        setIsLoading(false);
        setIsPageLoading(false);
      }
    }
  };

  const init = async (id, type) => {
    // await fetchEmployeeDetail(id);
    await getStepper();
    await getAllDropDowns();
    await getProfileData();
  };

  useEffect(() => {
    init(id, type);
  }, [id]);

  // When user navigates manually or clicks tabs, update currentStep accordingly:
  useEffect(() => {
    if (!isInitialLoad && stepRoutes.includes(pathSegment)) {
      setCurrentStep(pathSegment);
    }
  }, [pathSegment, isInitialLoad]);

  const steps = [
    { title: "Personal Details" },
    { title: "Employment & Identity" },
    { title: "Bank Details" },
    { title: "Documents" },
    { title: "Nominee & Declarations" },
    { title: "Appointment Letter" },
  ];

  const { token } = theme.useToken();
  const current =
    stepRoutes.indexOf(currentStep) !== -1
      ? stepRoutes.indexOf(currentStep)
      : 0;

  const onStepClick = (stepIndex) => {
    handleNavigate(stepRoutes[stepIndex]);
    // navigate(`/new-user/${stepRoutes[stepIndex]}`);
    getAllDropDowns();
    // getProfileData();
    fetchEmployeeDetail();
  };

  const currentIndex = stepRoutes.indexOf(pathSegment);

  const goBack = () => {
    if (currentIndex > 0) {
      handleNavigate(stepRoutes[currentIndex - 1]);
      // navigate(`/new-user/${stepRoutes[currentIndex - 1]}`);
    }
    fetchEmployeeDetail();
  };

  const goNext = () => {
    if (currentIndex < stepRoutes.length - 1) {
      navigate(`/new-user/${stepRoutes[currentIndex + 1]}`);
    }
  };

  const items = steps.map((item, index) => {
    const isCurrent = index === current;

    const isActive = index <= current;
    const isEnabled = index <= maxCompletedStep;
    const isTailActive = index < maxCompletedStep;
    const currentInableActive = isActive || isEnabled;

    return {
      key: item.title,
      title: (
        <div
          className={`text-xs m-0 text-center   ${
            currentInableActive
              ? "font-bold text-primary"
              : "font-normal text-gray-500"
          }`}
        >
          {item.title}
        </div>
      ),
      icon: (
        <div
          style={{ border: isCurrent && "1px solid #009bde" }}
          className={`
      inline-flex items-center justify-center rounded-full 
      ${isCurrent ? " scale-110 shadow-2xl " : ""}
    `}
        >
          <div
            className={`w-5 h-5 m-[1px] rounded-full flex items-center justify-center   
           
           font-semibold ${
             currentInableActive ? "text-white" : "text-gray-500"
           }`}
            style={{
              fontSize: "10px",
              lineHeight: 1,
              border: currentInableActive
                ? "none"
                : `1.5px solid ${token.colorBorderSecondary}`,
              backgroundColor: currentInableActive ? "#009bde" : "transparent",
              display: "inline-flex",
              verticalAlign: "middle",
            }}
          >
            {index + 1}
          </div>
        </div>
      ),
      className: isTailActive ? "step-tail-primary" : "", // 👈 apply a class to control tail
      disabled: type !== "admin" && !isEnabled,
    };
  });

  return (
    <>
      {contextHolder}
      <Helmet>
        <style>{`body { background: #F4F4F9; }`}</style>
      </Helmet>
      <PageLoader loading={isPageLoading} />
      {(type === "admin" && (
        <>
          {" "}
          <MobileSideNavbar
            type="admin"
            isNavbarOpen={isNavbarOpen}
            setIsNavbarOpen={setIsNavbarOpen}
          />
          <SideNavbar type="admin" />
        </>
      )) || (
        <>
          <MobileSideNavbar
            type="new-user"
            isNavbarOpen={isNavbarOpen}
            setIsNavbarOpen={setIsNavbarOpen}
          />
          <SideNavbar type="new-user" />
        </>
      )}
      {/*
       */}
      <div id="dashboard-body" style={{ margin: "0px 0px 0px 256px" }}>
        <TopNavbar setIsNavbarOpen={setIsNavbarOpen} type="new-user" />
        <div className="dashboard-subbody mt-3">
          {responseData && <UserDetail responseData={responseData} />}
          <div className="flex justify-between">
            <h3 className="my-6 mx-1">Employee Joining Form</h3>
            <span className="my-6 mx-1 text-[#898F8F]">
              STEP {current + 1} OF {steps.length}
            </span>
          </div>
          <section className="bg-white p-6 shadow-sm border w-full rounded-lg">
            <Steps
              labelPlacement="vertical"
              className="custom-steps responsive-hidden"
              style={{ maxHeight: "70px", cursor: "pointer" }}
              current={current}
              items={items}
              onChange={onStepClick}
            />
          </section>
          <div
            className="py-3 rounded-lg mt-4 bg-white p-6 shadow-sm border"
            style={{
              height: "calc(100% - 76px)",
              overflow: "auto",
              boxShadow:
                "rgb(0 0 0 / 10%) 0px 1px 0px 0px, rgb(0 0 0 / 10%) 0px 2px 0px 0px",
            }}
          >
            {(isLoadingData && <Loader loading={true} />) || (
              <>
                {responseData && (
                  <Outlet
                    context={{
                      responseData,
                      dropDowns,
                      profileData,
                      isLoading,
                      id,
                    }}
                  />
                )}
              </>
            )}
          </div>
          {type !== "admin" && (
            <div
              className="flex flex-wrap gap-3 mt-4"
              style={{ marginBottom: 20, justifyContent: "center" }}
            >
              {/* <Button
                type="default"
                size="middle"
                disabled={currentIndex <= 0}
                onClick={goBack}
              >
                Back
              </Button>
              <Button
                type="primary"
                size="middle"
                disabled={currentIndex === stepRoutes.length - 1}
                onClick={goNext}
              >
                Next
              </Button> */}
            </div>
          )}
        </div>
      </div>
    </>
  );
}
